var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYkbLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114,
    height: 20,
    viewBox: "0 0 114 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ykb-logo",
    transform: "translate(-370 -26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5021",
    "data-name": "Group 5021",
    transform: "translate(370 26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4307",
    "data-name": "Path 4307",
    d: "M100.152,192.674a9.665,9.665,0,0,0-8.757-6.426,11.057,11.057,0,0,0-7.943,3.112,14.2,14.2,0,0,0-2.252,2.808h0a14.149,14.149,0,0,0-2.246-2.808,11.067,11.067,0,0,0-7.948-3.112,9.656,9.656,0,0,0-8.75,6.426,9.256,9.256,0,0,0,.539,7.059,7.082,7.082,0,0,0,6.561,4.138,5.742,5.742,0,0,0,5.072-3.434,4.98,4.98,0,0,0-1.112-5.472,2,2,0,0,1-.344,1.5,2.2,2.2,0,0,1-2.693.729,1.8,1.8,0,0,1-1.174-1.974A2.1,2.1,0,0,1,70.4,193.6a2.956,2.956,0,0,1,3.462.795c1.805,2.028,2.017,5.1,2.876,7.435.608,1.92,1.571,3.59,3.679,4.067a3.436,3.436,0,0,0,.785.085h0a3.376,3.376,0,0,0,.785-.085c2.11-.477,3.072-2.147,3.68-4.067.859-2.333,1.071-5.406,2.882-7.435A2.946,2.946,0,0,1,92,193.6a2.1,2.1,0,0,1,1.295,1.616,1.792,1.792,0,0,1-1.175,1.974,2.2,2.2,0,0,1-2.693-.729,1.992,1.992,0,0,1-.344-1.5,5,5,0,0,0-1.112,5.472,5.741,5.741,0,0,0,5.072,3.434,7.081,7.081,0,0,0,6.562-4.138A9.261,9.261,0,0,0,100.152,192.674Zm-4.258,7.248a4.105,4.105,0,0,1-4.366.834,2.974,2.974,0,0,1-1.623-1.883,3.411,3.411,0,0,0,5.187-.282,4.623,4.623,0,0,0,.78-4.832,5.074,5.074,0,0,0-4-3.022,6.043,6.043,0,0,0-6.138,2.6c-1.822,2.822-2.051,5.965-3.37,9.105a1.159,1.159,0,0,1-1.163.719h0a1.165,1.165,0,0,1-1.163-.719c-1.318-3.14-1.547-6.283-3.369-9.105a6.038,6.038,0,0,0-6.138-2.6,5.083,5.083,0,0,0-4,3.022,4.625,4.625,0,0,0,.78,4.832,3.418,3.418,0,0,0,5.193.282,3,3,0,0,1-1.629,1.883,4.105,4.105,0,0,1-4.366-.834,6.1,6.1,0,0,1-1.426-6.52,6.661,6.661,0,0,1,5.793-4.227,8.372,8.372,0,0,1,7.513,4.042c.327.622,1.02,2.227,1.02,2.227H83s.688-1.6,1.019-2.227a8.358,8.358,0,0,1,7.508-4.042A6.659,6.659,0,0,1,97.32,193.4,6.09,6.09,0,0,1,95.894,199.922Z",
    transform: "translate(-61.797 -186.246)",
    fill: "#96999c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5020",
    "data-name": "Group 5020",
    transform: "translate(39.604 0.44)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6121",
    "data-name": "Rectangle 6121",
    width: 3.252,
    height: 2.64,
    transform: "translate(71.144 0.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4308",
    "data-name": "Path 4308",
    d: "M173.479,196.836v7.156H169.8v-7.156l-3.226-9.372h3.9l1.163,4.6,1.186-4.6h3.9Z",
    transform: "translate(-166.574 -187.442)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4309",
    "data-name": "Path 4309",
    d: "M195.9,210.027l-.143-.626a2.88,2.88,0,0,1-2.459.938,2.444,2.444,0,0,1-2.293-2.726l.029-2.129c.058-3.465,4.75-2.414,4.75-5,0-.541-.028-.994-.653-.994-.591,0-.762.453-.762.994v1.051H191.04v-1.051c0-2.245,1.92-3.3,4.1-3.3,2.774,0,4.052,1.563,4.052,3.267v9.57Zm-.173-6.3c-.79.511-1.357.767-1.357,1.815v1.536c0,.736.2,1.022.682,1.022s.675-.285.675-1.022Z",
    transform: "translate(-181.773 -193.477)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4310",
    "data-name": "Path 4310",
    d: "M225.019,206.7c0,1.991-.339,3.66-2.544,3.66a2.577,2.577,0,0,1-2.407-1.137v3.863h-3.249V197.521h3.249l-.023,1.277a2.544,2.544,0,0,1,2.6-1.535c1.783,0,2.374,1.7,2.374,3.323v6.11Zm-3.479-5.854c0-.569-.31-.88-.733-.88-.454,0-.762.34-.762.937v5.933c0,.568.308.88.732.88.454,0,.764-.312.764-.907Z",
    transform: "translate(-197.827 -193.523)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4311",
    "data-name": "Path 4311",
    d: "M242.651,210.54V198.016H245.9V210.54Z",
    transform: "translate(-213.895 -193.989)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4312",
    "data-name": "Path 4312",
    d: "M261.968,203.935l-2.125-5.793-.5.908v4.885h-3.679V187.4h3.679v5.139l2.344-5.139h3.649l-3.363,6.958,3.65,9.571Z",
    transform: "translate(-221.986 -187.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4313",
    "data-name": "Path 4313",
    d: "M290.628,200.909c-.82-.312-3-.339-3,1.676v7.442h-3.258V197.5H287.4l-.028,1.334a3.439,3.439,0,0,1,3.228-1.647v3.719Z",
    transform: "translate(-239.848 -193.477)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4314",
    "data-name": "Path 4314",
    d: "M311.72,206.963c0,2.5-1.726,3.468-4.073,3.468-2.148,0-4.075-1.052-4.075-3.522v-5.85c0-2.385,1.444-3.721,4.075-3.721,2.15,0,4.073.882,4.073,3.751v3.3h-4.78v3.008c0,.51.223.8.707.8s.707-.285.707-.8v-1.846h3.366v1.416Zm-3.422-6.587c0-.509-.226-.792-.678-.792-.479,0-.707.283-.707.792v1.706h1.414Z",
    transform: "translate(-251.79 -193.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4315",
    "data-name": "Path 4315",
    d: "M333.937,203.992v-1.279a2.336,2.336,0,0,1-2.545,1.535c-2.009,0-2.4-1.7-2.4-3.294v-6.08c0-1.988.478-3.719,2.488-3.719a2.881,2.881,0,0,1,2.458,1.135v-4.825h3.256v16.528Zm0-9.316c0-.567-.307-.881-.759-.852-.452,0-.767.312-.767.881l.031,5.963c0,.571.312.88.736.88.452,0,.759-.341.759-.909Z",
    transform: "translate(-267.601 -187.442)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4316",
    "data-name": "Path 4316",
    d: "M354.8,210.586V198.062h3.253v12.524Z",
    transform: "translate(-283.651 -194.018)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYkbLogo);
export default __webpack_public_path__ + "static/media/ykb-logo.81699376c04d8c8e8aa35f29f9a8be1c.svg";
export { ForwardRef as ReactComponent };